@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as m;
@use "styles/abstracts/mixins/typography" as t;

.demoModBannerWrapper {
    position: absolute;
    left: 50%;
    bottom: 120px;
    transform: translateX(-50%);
    padding: 8px;
    z-index: v.$z-index-ui-demo-mod-banner;
    background-color: v.$palette-white;
    box-shadow: v.$shadow-1;
    bottom: 16px;
    border-radius: 16px;
    width: calc(100% - 32px);

    @include m.containerMedia(tablet, "min") {
        width: calc(100% - 40px);
    }

    @include m.containerMedia(1200, "min") {
        width: 1170px;
    }

    &.shouldHideOnPanel {
        transform: translateX(100%);
    }
}

.demoModBanner {
    color: v.$palette-gray-900;
    background-color: #FFF2E8;
    padding: 16px;
    border-radius: 10px;
    @include t.text(12px, 20px, 500);

    .link {
        margin: 0;
        padding: 0;
        @include t.text(12px, 20px, 600);
        text-decoration: underline;
        color: v.$palette-gray-900;
        
        &:visited {
            color: v.$palette-gray-900;
        }

        @include m.containerMedia(tablet, "min") {
            @include t.text(14px, 22px, 600);
        }
    }

    @include m.containerMedia(tablet, "min") {
        @include t.text(14px, 22px, 500);
    }
}